import {
  AlertDialogHeader as AlertDialogHeaderPrimitive,
  type ModalHeaderProps
} from '@chakra-ui/react';
import { ReactNode } from 'react';

export function AlertDialogHeader(props: ModalHeaderProps): ReactNode {
  return (
    <AlertDialogHeaderPrimitive
      textAlign="center"
      paddingBottom="0"
      {...props}
    />
  );
}
